export const GET_ARTICLE_LIST = "GET_ARTICLE_LIST"
export const GET_ARTICLE_LIST_FAIL = "GET_ARTICLE_LIST_FAIL"
export const GET_ARTICLE_LIST_SUCCESS = "GET_ARTICLE_LIST_SUCCESS"
export const GET_ARTICLE_LIST_RESET = "GET_ARTICLE_LIST_RESET"

export const getArticleList = (params) => {
    return { type: GET_ARTICLE_LIST, params }
}
export const getArticleListFail = (response) => {
    return { type: GET_ARTICLE_LIST_FAIL, response }
}
export const getArticleListSuccess = (response) => {
    return { type: GET_ARTICLE_LIST_SUCCESS, response }
}
export const getArticleListReset = () => {
    return { type: GET_ARTICLE_LIST_RESET }
}